import { useRouter } from 'next/router';
import RoutePageComponent from '@/components/RoutePage/desktop';
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import {
  addAllPointsHomePoints,
} from '@/slices/area/slices/searchFlightFormSlice';

import { getRoutePageMeta, getRoutePageTitle, lunarYear } from '@/utils/seoHelper';
import Head from 'next/head';
import { getDate, getMonth } from 'date-fns';
import { useEffect } from 'react';
import { getRoutePageMetaJson } from '@/utils/getProductMetaJson';

function RoutePageContainer({
  startPoint, endPoint, countResult, countSeoResult, countSeoAllResult, countSeoReturnResult, countSeoTetResult, countTetResult,
}: any) {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const headerTabs = useAppSelector((state) => state.headerTabs || 0);

  useEffect(() => {
    setTimeout(() => {
      if (startPoint && endPoint) {
        dispatch(addAllPointsHomePoints([
          {
            data: startPoint,
            type: 'from',
          }, {
            data: endPoint,
            type: 'to',
          },
        ]));
      }
    });
  }, []);

  if (!startPoint || !endPoint) return null;

  let path = process.env.GOYOLO_URL + router.asPath;
  if (typeof window !== 'undefined') {
    path = window.location.href;
  }

  const today = new Date();
  const productJson = getRoutePageMetaJson(endPoint, startPoint);
  return (
    <div>
      <Head>
        <title>{getRoutePageTitle(startPoint?.location || '', endPoint?.location || '')}</title>
        <meta
          name="description"
          content={getRoutePageMeta(startPoint?.location || '', endPoint?.location || '')}
        />
        <meta
          name="google-site-verification"
          content={process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION}
        />
        <meta
          name="og:type"
          property="og:type"
          content="Product"
        />
        <meta
          name="og:title"
          property="og:title"
          content={`[GIẢM 20K] Đặt mua vé máy bay ${startPoint?.location} đi ${endPoint?.location} giá rẻ nhất ngày ${getDate(today)}, tháng ${getMonth(today) + 1}| Goyolo.com`}
        />
        <meta
          name="og:description"
          property="og:description"
          content={`Săn vé máy bay từ ${startPoint?.location} đi ${endPoint?.location} với nhiều khuyến mãi, đặt mua online vé máy bay đi ${endPoint?.location} giá rẻ nhất, nhanh chóng, thuận tiện không thuế, không phí, tra cứu thông tin bảng giá, hủy đổi vé dễ dàng. Đặt mua vé máy bay Tết ${lunarYear} đi ${endPoint?.location} ngay tại Goyolo.com`}
        />
        <meta
          name="og:image"
          property="og:image"
          content={process.env.NEXT_PUBLIC_LOGO_LINK}
        />
        <meta
          name="og:image:alt"
          property="og:image:alt"
          content={`Goyolo.com săn vé máy bay từ ${startPoint?.location} đi ${endPoint?.location} giá rẻ`}
        />
        <meta
          name="og:locale"
          property="og:locale"
          content="vi"
        />
        <meta
          name="og:url"
          property="og:url"
          content={path}
        />
        <meta
          name="og:site_name"
          property="og:site_name"
          content="Goyolo.com"
        />
        <meta
          name="fb:app_id"
          property="fb:app_id"
          content="https://www.facebook.com/Goyolocom-103117924769137"
        />
        <link
          rel="alternate"
          type="text/html"
          href={path}
          hrefLang="x-default"
          title="Tiếng Việt"
        />
        <link
          rel="canonical"
          href={path}
        />
        <script
          type="application/ld+json"
        >
          {productJson}
        </script>
      </Head>
      <RoutePageComponent
        headerTabs={headerTabs}
        startPoint={startPoint}
        toPoint={endPoint}
        countSeoTetResult={countSeoTetResult}
        countResult={countResult}
        countTetResult={countTetResult}
        countSeoResult={countSeoResult}
        countSeoAllResult={countSeoAllResult}
        countSeoReturnResult={countSeoReturnResult}
      />
    </div>
  );
}

export default RoutePageContainer;
